import { Component, OnInit } from '@angular/core'
import { CalendarDay } from '../../../../Interfaces/CalendarDay'

@Component({
  selector: 'atyl-week',
  templateUrl: './week.component.html',
  styleUrls: ['./week.component.scss']
})
export class WeekComponent implements OnInit {

  calendar: CalendarDay[] = [];
  monthNames = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
    'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
  ];
  weekDays = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];
  displayMonth: string
  private monthIndex: number = 0;

  ngOnInit(): void {
    this.generateCalendarDays(this.monthIndex)
  }

  private generateCalendarDays(monthIndex: number): void {
    this.calendar = []

    let day: Date = new Date(new Date().setMonth(new Date().getMonth() + monthIndex))

    this.displayMonth = this.monthNames[day.getMonth()]

    let startingDateOfCalendar = this.getStartDateForCalendar(day)

    let dateToAdd = startingDateOfCalendar

    for (var i = 0; i < 42; i++) {
      this.calendar.push(new CalendarDay(new Date(dateToAdd)))
      dateToAdd = new Date(dateToAdd.setDate(dateToAdd.getDate() + 1))
    }
  }

  private getStartDateForCalendar(selectedDate: Date) {
    let lastDayOfPreviousMonth = new Date(selectedDate.setDate(0))

    let startingDateOfCalendar: Date = lastDayOfPreviousMonth

    if (startingDateOfCalendar.getDay() != 1) {
      do {
        startingDateOfCalendar = new Date(startingDateOfCalendar.setDate(startingDateOfCalendar.getDate() - 1))
      } while (startingDateOfCalendar.getDay() != 1)
    }

    return startingDateOfCalendar
  }

  public increaseMonth() {
    this.monthIndex++
    this.generateCalendarDays(this.monthIndex)
  }

  public decreaseMonth() {
    this.monthIndex--
    this.generateCalendarDays(this.monthIndex)
  }

  public setCurrentMonth() {
    this.monthIndex = 0
    this.generateCalendarDays(this.monthIndex)
  }

}
